import { Queue } from '..'

export class LimitedQueue extends Queue {
  public limit

  public constructor(limit) {
    super()
    this.limit = limit
  }

  public enqueue(val) {
    let returnVal = null
    if (this.length >= this.limit) {
      returnVal = this.dequeue()
    }
    super.enqueue(val)
    return returnVal
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/limited-queue/limited-queue.ts